import { createFileRoute } from '@tanstack/react-router'
import { B2b2cRequests } from '@/features/b2b2c/requests'

export const Route = createFileRoute('/_authenticated/b2b2c/requests/')({
  component: B2b2cRequests,
})
